import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, canonical, image, robots = "index, follow", type = "website" }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("name", "robots", robots);
    setMeta("property", "og:type", type);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
      setMeta("name", "twitter:card", "summary_large_image");
    }
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
      setMeta("property", "og:url", canonical);
    }
  }, [title, description, canonical, image, robots, type]);
  return null;
};

const PRIVATE_PREFIXES = ["/app", "/admin", "/login", "/register", "/onboarding", "/verify-email"];

export const useRouteRobots = (pathname) => {
  useEffect(() => {
    const isPrivate = PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
    setMeta("name", "robots", isPrivate ? "noindex, nofollow" : "index, follow");
    if (isPrivate) {
      const link = document.head.querySelector('link[rel="canonical"]');
      if (link) link.remove();
    }
  }, [pathname]);
};
